export const NOTIFICATION_TYPES = Object.freeze({
  whatsNew: 'whats-new',
  whatsNewModal: 'whats-new-highlights'
})
